//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignUpForm from '@/components/forms/SignUpForm.vue';
export default {
  components: {
    SignUpForm
  }
};
